import { useEffect, useState, useLayoutEffect } from "react";
import { Row, Col } from "react-bootstrap"
import Search from "./header/Search"
import Header from "../Header";
import styles from "./style.module.css"
import { Tag } from "rsuite"
import { format, startOfMonth } from "date-fns"
import axiosService from "../../utils/axios.service";
import "./scss/report.scss"
import { Spin, Tabs, Tooltip } from 'antd';
import async from "async"
import 'antd/dist/antd.min.css'
import StorageService from "../../utils/storage.service";

import ViewOrderNoTvv from "./ktv/ViewOrderNoTvv"
import Rating from "./ktv/Rating"
import Reward from "./ktv/Reward"
import ViewDetailServiceUser from "./ktv/ViewDetailServiceUser"
import ViewDetailOrderServiceUser from "./ktv/ViewDetailOrderServiceUser"
import ViewDetailOrderServiceTvv from "./ktv/ViewDetailOrderServiceTvv"

const ReportKtvTvvOfflineDetail = () => {
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            JSON.parse(StorageService.getItem("user_info")).stores[0].id
        : parseInt(StorageService.getItem("currentStore")) )
    const [isExport, setIsExport] = useState(false)
    const [loading, setLoading] = useState(true);

    const [totalComPV, setTotalComPV] = useState(0)
    const [totalPaidTV, setTotalPaidTV] = useState(0)
    const [totalComTV, setTotalComTV] = useState(0)

    const [totalOrderKtv, setTotalOrderKtv] = useState(0)
    const [totalOrderTvv, setTotalOrderTvv] = useState(0)

    const [detailComPV, setDetailComPV] = useState([])
    const [detailComTV, setDetailComTV] = useState([])
    const [detailPVByProduct, setDetailPVByProduct] = useState([])
    const [orderNo, setOrderNo] = useState([])
    const [emulations, setEmulations] = useState([])
    const [rating, setRating] = useState([])

    const [keyword, setKeyword] = useState([])
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const [userId, setUserId] = useState(userAdmin.id)
    const [userName, setUserName] = useState(userAdmin.name)

    const title = "Chi tiết KTV"

    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }
    const handleStore = (x) => {
        setStore(x)
    }


    const handleUser = (x) => {
        setUserId(x.value)
        setUserName(x.label)
    }
    const fetchData = async (sD, eD, s) => {
        const { users, data } = await async.parallel({
            users: (cb) => {
                axiosService(`api/reports/store/users/${store}`, "GET").then(rs => {
                    const { data } = rs
                    cb(null, data)
                })
            },
            data: (cb) => {
                axiosService(`api/mysql/report-detail-user-ktv-tvv/all?type=1&user_id=${userId}&start=${sD}&end=${eD}`, "GET").then(rs => {
                    const { data } = rs
                    cb(null, data)
                })
            }
        })
        if (data.code === 200) {
            setLoading(false)
            const { summary, sellRate, detailPV, detailComTV, detailPVByProduct, orderNo, emulations, rating } = data.data
            setTotalComPV(summary?.totalComPV ?? 0)
            setTotalPaidTV(summary?.totalPaidTV ?? 0)
            setTotalComTV(summary?.totalComTV ?? 0)

            setTotalOrderKtv(sellRate.countPV)
            setTotalOrderTvv(sellRate.countTV)

            setDetailComPV(detailPV ?? [])
            setDetailComTV(detailComTV ?? [])
            setDetailPVByProduct(detailPVByProduct ?? [])
            setOrderNo(orderNo)
            setEmulations(emulations)
            setRating(rating)
        }

    }
    useLayoutEffect(() => {
        setLoading(true)
        fetchData(startDate, endDate, store)
    }, [startDate, endDate, store, userId])

    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };
   
    const handleExportData = () => {
        setIsExport(true)
        setTimeout(() => {
            setIsExport(false)
        }, 2000)
    }
    const onChangeKeyword = (e) => {
        setKeyword(e)
    }

    const itemsTab = [
        {
            key: '1',
            label: 'Chi tiết đơn phục vụ',
            children: (
                <ViewDetailOrderServiceUser
                    table={detailComPV}
                    startDate={startDate}
                    endDate={endDate}
                    userId={userId}
                    userName={userName}
                />
            ),
        },
        {
            key: '2',
            label: 'Chi tiết đơn tư vấn',
            children: (
                <ViewDetailOrderServiceTvv
                    table={detailComTV}
                    startDate={startDate}
                    endDate={endDate}
                    userId={userId}
                    userName={userName}
                />
            ),
        },
        {
            key: '3',
            label: 'Tổng quan phục vụ',
            children: (
                <ViewDetailServiceUser
                    table={detailPVByProduct}
                    startDate={startDate}
                    endDate={endDate}
                    userId={userId}
                    userName={userName}
                />
            ),
        },
        {
            key: '5',
            label: 'Đơn khách còn nợ',
            children: (
            <ViewOrderNoTvv
                table={orderNo}
                startDate={startDate}
                endDate={endDate}
                userId={userId}
                userName={userName}
            />
            ),
        },
        {
            key: '6',
            label: 'Thi đua',
            children: (
                <Reward
                    table={emulations}
                    startDate={startDate}
                    endDate={endDate}
                    userId={userId}
                    userName={userName}
                />
            ),
        },
        {
            key: '7',
            label: rating.average ? `Đánh giá (${rating.average} sao)` : 'Đánh giá',
            children: (
                <Rating
                    table={rating.data}
                    startDate={startDate}
                    endDate={endDate}
                    userId={userId}
                    userName={userName}
                />
            ),
        },
    ];
    return (
        <>
            <Header/>
            <div className={`container-fluid ${styles.background}`}>
                <Search startDate={startDate} endDate={endDate}
                    handleRangeDate={handleRangeDate} store={store}
                    handleStore={handleStore}
                    handleUser={handleUser}
                    title={title} type={"detail-ktv-tvv"}
                    csvData={[]} isExport={isExport}
                    handleExportData={handleExportData}
                    onChangeKeyword={onChangeKeyword}
                    header={[]}
                    userAdmin={userAdmin}
                />
                <Spin spinning={loading} tip="Đang tải...">
                    <Row>
                        <Col xs={12} xl={12}>
                            <Row className="h-100">
                                <Col xs={12} md={3} className="mb-2">
                                    <Tag color="green" className="w-100 p-2 h-100">
                                        <span className={styles.textTag3}>
                                            <Tooltip title='Tổng số tiền kỹ thuật viên được nhận khi phục vụ dịch vụ cho khách hàng.'>
                                                Thưởng phục vụ:   <i className="fas fa-info-circle"></i>
                                            </Tooltip>
                                        </span>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <span className={styles.textTag}> </span>
                                                <br />
                                            </div>
                                            <div className="ml-3">
                                                <span className={styles.textTag2}>{convertCurrency(totalComPV)}</span>
                                            </div>
                                        </div>
                                        <span className={styles.textTag3}>
                                            <Tooltip className="show-tooltip" title='Tổng số tiền thực tế đã thu được từ các đơn hàng đến từ nguồn Offline bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy.'> Tổng thực thu bán hàng:  <i className="fas fa-info-circle"></i></Tooltip>
                                        </span>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <span className={styles.textTag}> </span>
                                                <br />
                                            </div>
                                            <div className="ml-3">
                                                <span className={styles.textTag2}>
                                                    {convertCurrency(totalPaidTV)}</span>
                                                
                                            </div>
                                        </div>
                                        <span className={styles.textTag3}>
                                        <Tooltip className="show-tooltip" title='Tổng số tiền được thưởng cho kỹ thuật viên khi tư vấn cho khách hàng dựa trên số tiền khách thanh toán cho đơn hàng đó.'> Thưởng tư vấn:  <i className="fas fa-info-circle"></i></Tooltip>
                                        </span>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <span className={styles.textTag}> </span>
                                                <br />
                                            
                                            </div>
                                            <div className="ml-3">
                                                <span className={styles.textTag2}>
                                                    {convertCurrency(totalComTV)}</span>
                                            </div>
                                        </div>
                                    </Tag>
                                </Col>
                                <Col xs={12} md={3} className="mb-2">
                                    <Tag color="violet" className="w-100 p-2 h-100">
                                        <span className={styles.textTag3}>Tỷ lệ chốt đơn: </span>
                                        <div className="d-flex justify-content-between p-1">
                                            <div>
                                                <span  className={styles.textTag4}> <Tooltip title='Tổng số đơn hàng có chứa dịch vụ đã được ghi nhận thực hiện bởi kỹ thuật viên cho khách hàng trong ngày hoàn tất trên hệ thống.'>
                                                Tổng đơn hàng phục vụ:  <i className="fas fa-info-circle"></i>
                                            </Tooltip></span>
                                                <span  className={styles.textTag4}> <Tooltip title='Tổng số đơn hàng được tạo ra qua quá trình tư vấn trực tiếp từ nhân sự, và khách hàng đã đồng ý đăng ký, thanh toán hoặc thực hiện dịch vụ ngay sau tư vấn.'>
                                                Tổng đơn hàng tư vấn:  <i className="fas fa-info-circle"></i>
                                            </Tooltip></span>
                                                <span className={styles.textTag4}> Tỷ lệ đơn tư vấn/phục vụ:</span>
                
                                            </div>
                                            <div className="ml-3">
                                                <span className={styles.textTag3}>{totalOrderKtv}</span>
                                                <span className={styles.textTag3}>{totalOrderTvv}</span>
                                                <span className={styles.textTag3}>{totalOrderKtv > 0 ? ((totalOrderTvv / totalOrderKtv) * 100).toFixed(2) : '0'} %</span>
                                            </div>
                                        </div>
                                    </Tag>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Tabs defaultActiveKey="1" items={itemsTab} />
                        </Col>
                    </Row>
                </Spin>
            </div>
        </>
    )
}
export default ReportKtvTvvOfflineDetail